import { useEffect, useState } from "react";
import api from "./api";

export const FALLBACK_CONCIERGE_WA = "919004850588";
export const FALLBACK_CONCIERGE_PHONE = "919004850588";

const FALLBACK = {
    concierge_whatsapp: FALLBACK_CONCIERGE_WA,
    concierge_phone: FALLBACK_CONCIERGE_PHONE,
};

let cached = null;
let pending = null;

export function formatWaDisplay(num) {
    const d = (num || FALLBACK_CONCIERGE_WA).replace(/\D/g, "");
    if (d.length === 12 && d.startsWith("91")) return `+91 ${d.slice(2, 7)} ${d.slice(7)}`;
    return `+${d}`;
}

export function telHref(num) {
    return `tel:+${(num || FALLBACK_CONCIERGE_PHONE).replace(/\D/g, "")}`;
}

function fetchSettings() {
    if (cached) return Promise.resolve(cached);
    if (!pending) {
        pending = api
            .get("/settings/public")
            .then((r) => {
                cached = { ...FALLBACK, ...(r.data || {}) };
                return cached;
            })
            .catch(() => FALLBACK);
    }
    return pending;
}

/** Admin-configurable site contact settings (module-cached, one fetch per session). */
export function useSiteContact() {
    const [settings, setSettings] = useState(cached || FALLBACK);
    useEffect(() => {
        let on = true;
        fetchSettings().then((s) => on && setSettings(s));
        return () => {
            on = false;
        };
    }, []);
    return settings;
}

/** Concierge WhatsApp number. Pass an override (e.g. a destination's team number) to skip the global setting. */
export function useConciergeNumber(override) {
    const { concierge_whatsapp } = useSiteContact();
    return override || concierge_whatsapp;
}

/** Concierge voice-call number (used by tel: "Speak to a Concierge" CTAs). */
export function useConciergePhone() {
    const { concierge_phone } = useSiteContact();
    return concierge_phone;
}
